import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_USER + '/role/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_USER + '/role/update_status',
    method: 'post',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_USER + '/role/detail',
    method: 'get',
    params: data
  })
}

export function getRole() {
  return request({
    url: process.env.BASE_URL_USER + '/role/list',
    method: 'get',
  })
}

export function getRolePermission() {
  return request({
    url: process.env.BASE_URL_USER + '/role/roles_permissions',
    method: 'get',
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_USER + '/role/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_USER + '/role/update',
    method: 'put',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/role.js